// constants/eventConstants.js
export const FETCH_EVENT = 'src/Event/FETCH_EVENT';
export const FETCH_EVENTS = 'src/Event/FETCH_EVENTS';
export const EVENT_CHANGE = 'src/EVENT/EVENT_CHANGE';
export const EVENT_EDIT_CHANGE = 'src/EVENT/EVENT_EDIT_CHANGE';
export const SET_EVENT_FORM_ERRORS = 'src/EVENT/SET_EVENT_FORM_ERRORS';
export const SET_EVENT_FORM_EDIT_ERRORS = 'src/EVENT/SET_EVENT_FORM_EDIT_ERRORS';
export const RESET_EVENT = 'src/EVENT/RESET_EVENT';
export const ADD_EVENT = 'src/EVENT/ADD_EVENT';
export const REMOVE_EVENT = 'src/EVENT/REMOVE_EVENT';
export const FETCH_EVENTS_SELECT = 'src/EVENT/FETCH_EVENTS_SELECT';
export const SET_EVENTS_LOADING = 'src/EVENT/SET_EVENTS_LOADING';
export const SET_ADVANCED_FILTERS = 'src/EVENT/SET_ADVANCED_FILTERS';
export const RESET_ADVANCED_FILTERS = 'src/EVENT/RESET_ADVANCED_FILTERS';
export const IMAGE_TO_REMOVE = 'src/Event/IMAGE_TO_REMOVE';
export const CREATE_EVENT_TICKET = 'src/Event/CREATE_EVENT_TICKET';
export const DELETE_EVENT_TICKET = 'src/Event/DELETE_EVENT_TICKET';
export const EDIT_EVENT_TICKET = 'src/Event/EDIT_EVENT_TICKET';
export const FETCH_USER_EVENT = 'src/Event/FETCH_USER_EVENT';
export const FETCH_ALL_EVENTS = 'src/Event/FETCH_ALL_EVENTS';
export const SELECT_EVENT = 'src/Event/SELECT_EVENT';
export const VIEWING_EVENT = 'src/Event/VIEWING_EVENT';
export const EVENT_CHANGED = 'src/Event/EVENT_CHANGED';
export const FETCH_MY_AT_EVENTS = 'src/Event/FETCH_MY_AT_EVENTS';
export const FETCH_MY_G_EVENTS = 'src/Event/FETCH_MY_G_EVENTS';
